<template>
  <div class="popup_base">
    <div class="popup" v-click-outside="closePopup">
      <!-- 確認ダイアログ -->
      <template v-if="confirmDialog">
        <h1>{{ t('確認') }}</h1>
        <p>{{ t('所持ポイント') }}</p>
        <p>{{ formatAvailablePoint }}</p>
        <p>{{ t('ランク維持してよろしいですか') }}</p>
        <div class="button_area">
          <BlackGradationButton
            class="cancel-button"
            :text="t('キャンセル')"
            @handleSquareBtnClick="closePopup"
          />
          <BlackGradationButton
            class="ok-button2"
            :text="t('はい')"
            @handleSquareBtnClick="handleConfirm"
          />
        </div>
      </template>
      <!-- ランク維持確認 -->
      <template v-else-if="currentUserDetail.rank_coin  && !isSuccess">
        <h1>{{ t('ランク維持確認') }}</h1>
        <p class="rank-message">
          {{ formatRankName }}
          <br>
          {{ formatNextRankName }}
        </p>
        <p class="rank-coin">
          {{ formatNextMessage }}
        </p>
        <ErrorMessage v-if="errorMessage" :message="t(errorMessage)" />
        <div class="button_area">
          <BlackGradationButton
            class="cancel-button"
            :text="t('キャンセル')"
            @handleSquareBtnClick="closePopup"
          />
          <BlackGradationButton
            class="ok-button2"
            :text="t('支払う')"
            @handleSquareBtnClick="handlePayment"
          />
        </div>
      </template>
      <!-- ランク維持完了後 -->
      <template v-else>
        <h1>{{ t('ランク維持確認') }}</h1>
        <p>{{ t('すでにランク維持を完了しています。') }}</p>
        <div class="button_area">
          <BlackGradationButton
            class="cancel-button"
            :text="t('閉じる')"
            @handleSquareBtnClick="closePopup"
          />
        </div>
      </template>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import t from '@/plugins/i18n';
import {
  separateCharacterNumber,
} from '@/common/util/format';

export default {
  name: 'RankPopup',
  mixins: [t],

  components: {
    BlackGradationButton,
    ErrorMessage,
  },

  props: {
    currentUserDetail: {
      type: Object,
      required: true,
    },
    currentUser: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      errorMessage: '',
      isSuccess: false,
      confirmDialog: false,
    };
  },

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },

  computed: {
    ...mapGetters({
      buyRankResult: 'user/buyRankResult',
    }),
    formatRankName() {
      const rank = this.currentUserDetail.rank_name;
      if (!rank) return null;
      const lang = this.currentUser?.language || 'ja';
      const key = '現在のランクは「{rank}」です。';
      const template = this.i18n_message?.[key]?.[lang] || key;
      return template.replace('{rank}', rank);
    },
    formatNextRankName() {
      const rank = this.currentUserDetail.next_month_name;
      if (!rank) return null;
      const lang = this.currentUser?.language || 'ja';
      const key = 'ポイントを使用しない場合、来月は「{rank}」ランクになります。';
      const template = this.i18n_message?.[key]?.[lang] || key;
      return template.replace('{rank}', rank);
    },
    formatNextMessage() {
      const rank = this.currentUserDetail.next_rank_name;
      const amount = this.currentUserDetail.rank_coin;
      if (!amount) return null;
      const lang = this.currentUser?.language || 'ja';
      const key = '来月、「{rank}」からスタートするには {amount} ポイントが必要です。';
      const template = this.i18n_message?.[key]?.[lang] || key;
      return template.replace('{rank}', rank).replace('{amount}', amount);
    },
    formatAvailablePoint() {
      const nowCoin = this.currentUserDetail.availablePoint;
      const useCoin = this.currentUserDetail.rank_coin;
      const result = nowCoin - useCoin;
      return `${this.$options.filters.comma(nowCoin)}Coin ➤ ${this.$options.filters.comma(result)}Coin`;
    },
  },

  watch: {
    buyRankResult(newVal) {
      if (!newVal) return;
      if (newVal.state === 200) {
        this.isSuccess = true;
        this.$store.dispatch('user/setCurrentUserDetail');
        this.$store.dispatch('user/setCurrentUser');
        alert(this.t('ランク維持が完了しました'));
        this.closePopup();
      } else if (newVal.errors) {
        // this.errorMessage = newVal.errors.user_id || 'エラーが発生しました';
        const { count } = newVal.errors;
        alert(count[0]);
      }
    },
  },

  methods: {
    confirmBuyRank() {
      const postParams = {
        coin: this.currentUserDetail.rank_coin,
        next_month_rank: this.currentUserDetail.next_month,
      };
      this.$store.dispatch('user/buyRank', { postParams });
    },
    handleConfirm() {
      this.isSuccess = true;
      this.confirmBuyRank(); // 本処理
    },
    closePopup() {
      this.$emit('closePopup');
      this.$store.dispatch('user/clearBuyRankResult');
    },
    handlePayment() {
      this.errorMessage = '';
      if (this.currentUserDetail.rank_coin > this.currentUserDetail.availablePoint) {
        this.errorMessage = 'ポイントが不足しています';
        return;
      }
      this.confirmDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.popup_base {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;

  .popup {
    background-color: white;
    padding: 60px;
    border-radius: 10px;
    max-width: 400px;
    width: 90%;
    text-align: center;

    h1 {
      font-size: 22px;
      margin-bottom: 20px;
    }

    .rank-message {
      font-size: 16px;
      margin-bottom: 20px;
    }

    .success-message {
      font-size: 20px;
      color: green;
      margin-bottom: 20px;
    }

    .button_area {
      display: flex;
      justify-content: space-around;
      margin-top: 20px;
      .cancel-button {
        background-color: $gray;
        width: 45%;
        height: 35px;
      }
      .ok-button2 {
        width: 45%;
        height: 35px;
      }
    }
    @media screen and (max-width: $tabletWidth) {
      padding: 20px;
    }
  }
}
</style>
